export class PsNotificationIcon {

    _icon; // string

    constructor(
        icon,
    ) {
        this._icon = icon;
    }

    static fromAPINotification(notification) {
        if ( notification.construction ) {
            return new this('nature_people');
        }

        if ( notification.worker ) {
            return new this('account_circle');
        }

        if ( notification.machine ) {
            return new this('local_shipping');
        }

        if ( notification.machine ) {
            return new this('local_shipping');
        }

        if ( notification.company ) {
            return new this('build');
        }

        return new this('file_copy');
    }

    icon() {
        return this._icon;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/PsNotificationIcon.js